// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__StF7a","label":"Category_label__3PKft","content":"Category_content__2chhg","header":"Category_header__Q1s02","location":"Category_location__2tfIX"};